import Vue from "vue"

const routing = Vue.observable({ isRouting: true })

export default routing
